import React, { useContext } from 'react';
import { Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { LayerContext } from '../LayerContext';
import { loadLayerAndDispatch } from '../SideBar/AddAssetButton'

const AddGeneGroupButton = ({ geneGroupItems, map, genePMTilesLocation, catalogId, clearGeneGroupItems, handleCloseGeneGroupDialog }) => {

  const { dispatch } = useContext(LayerContext);

  const handleClickAddGenesToLayer = (event) => {
    const location = genePMTilesLocation.endsWith('/') ? genePMTilesLocation.slice(0, -1) : genePMTilesLocation;
    if (geneGroupItems.length > 1) {
      const pmtilesUrls = geneGroupItems.map(item => `${location}/${item.gene}.pmtiles`);
      loadLayerAndDispatch(
        map.current,
        pmtilesUrls,
        'GENE_GROUP',
        dispatch,
        false, // zoomTo
        catalogId
      );
    } else if (geneGroupItems.length === 1) {
      const pmtilesUrl = `${location}/${geneGroupItems[0].gene}.pmtiles`;
      loadLayerAndDispatch(
        map.current,
        pmtilesUrl,
        'GENE',
        dispatch,
        false, // zoomTo
        catalogId
      );
    }
    // clear geneGroupItems and close dialog
    clearGeneGroupItems();
    handleCloseGeneGroupDialog();
  };

  return (
    <Tooltip title="Add selected genes to a single layer">
      <Button
        className='gene-group-button'
        variant="outlined"
        color="success" size="small"
        onClick={handleClickAddGenesToLayer}>
        Add
      </Button>
    </Tooltip>
  )
}

export default AddGeneGroupButton;
